webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_aboutus_IndexAboutus__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_aboutus_IndexAboutus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_aboutus_IndexAboutus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_applyproject_IndexApplyproject__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_applyproject_IndexApplyproject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_applyproject_IndexApplyproject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_contactus_IndexContactus__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_contactus_IndexContactus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_contactus_IndexContactus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_home_IndexHome__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_home_IndexHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_home_IndexHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_pagenotfound_IndexPagenotfound__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_pagenotfound_IndexPagenotfound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_pagenotfound_IndexPagenotfound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_portofolios_IndexPortofolios__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_portofolios_IndexPortofolios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_portofolios_IndexPortofolios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_portofolios_ShowPortofolio__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_portofolios_ShowPortofolio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_portofolios_ShowPortofolio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_services_IndexServices__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_services_IndexServices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_services_IndexServices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_registration_IndexRegistration__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_registration_IndexRegistration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_registration_IndexRegistration__);
/* eslint-disable space-before-function-paren */
/* eslint-disable semi */
/* eslint-disable comma-dangle */












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: "/",
    name: "IndexHome",
    component: __WEBPACK_IMPORTED_MODULE_5__views_home_IndexHome___default.a
  }, {
    path: "/about-us",
    name: "IndexAboutus",
    component: __WEBPACK_IMPORTED_MODULE_2__views_aboutus_IndexAboutus___default.a
  }, {
    path: "/apply-project",
    name: "IndexApplyproject",
    component: __WEBPACK_IMPORTED_MODULE_3__views_applyproject_IndexApplyproject___default.a
  }, {
    path: "/contact-us",
    name: "IndexContactus",
    component: __WEBPACK_IMPORTED_MODULE_4__views_contactus_IndexContactus___default.a
  }, {
    path: "/portofolios",
    redirect: "/portofolios",
    name: "Portofolios",
    component: {
      render: function render(c) {
        return c("router-view");
      }
    },
    children: [{
      path: "/",
      name: "IndexPortofolios",
      component: __WEBPACK_IMPORTED_MODULE_7__views_portofolios_IndexPortofolios___default.a
    }, {
      path: "detail/:id",
      name: "ShowPortofolio",
      component: __WEBPACK_IMPORTED_MODULE_8__views_portofolios_ShowPortofolio___default.a
    }]
  }, {
    path: "/services",
    name: "IndexServices",
    component: __WEBPACK_IMPORTED_MODULE_9__views_services_IndexServices___default.a
  }, {
    path: "/registration",
    name: "IndexRegistration",
    component: __WEBPACK_IMPORTED_MODULE_10__views_registration_IndexRegistration___default.a
  }, {
    path: "*",
    component: __WEBPACK_IMPORTED_MODULE_6__views_pagenotfound_IndexPagenotfound___default.a
  }]
}));

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appHeader__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_appHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_appHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appFooterintermezo__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_appFooterintermezo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_appFooterintermezo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appFooter__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_appFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_appFooter__);
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    appHeader: __WEBPACK_IMPORTED_MODULE_0__components_appHeader___default.a,
    appFooterintermezo: __WEBPACK_IMPORTED_MODULE_1__components_appFooterintermezo___default.a,
    appFooter: __WEBPACK_IMPORTED_MODULE_2__components_appFooter___default.a
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({ name: 'appFooter' });

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({ name: 'appFooterintermezo' });

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({ name: 'appHeader' });

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexAboutus',
  data: function data() {
    return {
      about_us: {},
      team: []
    };
  },
  created: function created() {
    var _this = this;

    var options = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Api-Key': 'dhiDH@AWIAWDWd&7wd7q8wqyddwjqkhq67612836178sdqydq='
      }
    };

    var body = new FormData();
    body.append('security_key', 'NjZhYzFiZTNhZDI2Yzc3MGUyMWVkOGUwNGQzNzFlMzJkZDBkNTZmNw==');

    this.axios.post('http://dev.lusaraproject.com/api/about_us', body, options).then(function (response) {
      console.log(response.data);
      _this.about_us = response.data.about_us;
      _this.team = response.data.team;
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(60);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexApplyproject',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexContactus',
  data: function data() {
    return {
      msg: 'Index contact us'
    };
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexHome',
  data: function data() {
    return {
      about_us: [],
      lates_project: []
    };
  },
  created: function created() {
    var _this = this;

    var options = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Api-Key': 'dhiDH@AWIAWDWd&7wd7q8wqyddwjqkhq67612836178sdqydq='
      }
    };

    var body = new FormData();
    body.append('security_key', 'NjZhYzFiZTNhZDI2Yzc3MGUyMWVkOGUwNGQzNzFlMzJkZDBkNTZmNw==');

    this.axios.post('http://dev.lusaraproject.com/api/dashboard', body, options).then(function (response) {
      console.log(response.data);
      _this.lates_project = response.data.lates_project;
      _this.about_us = response.data.about_us;
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Pagenotfound',
  data: function data() {
    return {
      msg: 'Maaf, halaman tidak ditemukan dalam sistem'
    };
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexPortofolios',
  data: function data() {
    return {
      portofolio: []
    };
  },
  created: function created() {
    var _this = this;

    var options = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Api-Key': 'dhiDH@AWIAWDWd&7wd7q8wqyddwjqkhq67612836178sdqydq='
      }
    };

    var body = new FormData();
    body.append('security_key', 'NjZhYzFiZTNhZDI2Yzc3MGUyMWVkOGUwNGQzNzFlMzJkZDBkNTZmNw==');

    this.axios.post('http://dev.lusaraproject.com/api/portfolio', body, options).then(function (response) {
      console.log(response.data);
      _this.portofolio = response.data;
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPortofolio',
  data: function data() {
    return {
      msg: 'show portofolio'
    };
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexRegistration',
  data: function data() {
    return {
      cname: '', address: '', telpnum: '', cperson: '', region: '', city: ''
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      // axios.post(``)
      alert('Vue version : ' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].version);
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexServices',
  data: function data() {
    return {
      our_services: [],
      teknologi: []
    };
  },
  created: function created() {
    var _self = this;
    var options = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Api-Key': 'dhiDH@AWIAWDWd&7wd7q8wqyddwjqkhq67612836178sdqydq='
      }
    };

    var body = new FormData();
    body.append('security_key', 'NjZhYzFiZTNhZDI2Yzc3MGUyMWVkOGUwNGQzNzFlMzJkZDBkNTZmNw==');

    _self.axios.all([_self.axios.post('http://dev.lusaraproject.com/api/dashboard', body, options), _self.axios.post('http://dev.lusaraproject.com/api/services', body, options)]).then(_self.axios.spread(function (dashboard, service) {
      console.log(dashboard.data.teknologi);
      console.log(service.data.our_services);
      _self.teknologi = dashboard.data.teknologi;
      _self.our_services = service.data.our_services;
    })).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.cddc33e.png";

/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(83),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(85),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(80),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bf0ed81",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(82),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-75b79e9d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(79),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50846aa1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(75),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19208cf6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(76),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-26c9ad43",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(81),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-739fb421",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(74),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-17b566d3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(77),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b304ab9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(73),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1700eb7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexServices"
    }
  }, [_c('section', {
    staticClass: "sub--header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tServis Kami\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'apply-project'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t  Konsultasikan pada kami\n\t\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "nav-target",
    attrs: {
      "id": "navigation-type-service"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-list-nav"
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#bussinessprocess"
    }
  }, [_vm._v("Bussines Proces")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#company-profile"
    }
  }, [_vm._v("Company Profile")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#ecommerce"
    }
  }, [_vm._v("E-Commerce")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#sisteminformasi"
    }
  }, [_vm._v("Sistem Informasi")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#buildstartup"
    }
  }, [_vm._v("Build Start Up")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#webapplication"
    }
  }, [_vm._v("Web App")])]), _vm._v(" "), _c('li', {
    staticClass: "tech"
  }, [_c('a', {
    staticClass: "jump-target",
    attrs: {
      "data-target-jump": "#technologies"
    }
  }, [_vm._v("Technologies")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper service-page-wrapper bg-white",
    attrs: {
      "id": "bussinessprocess"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPROCESS BUSSINES/AGILE PROJECT MANAGEMENT\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe necessitatibus temporibus sint, soluta, repellat eum suscipit dolorum numquam sunt reiciendis perferendis dolores velit ad voluptas architecto accusamus, placeat eveniet ipsam?\n\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "service-wrapper__image-process"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/agile.png",
      "alt": ""
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-grey2",
    attrs: {
      "id": "company-profile"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tCompany Profile\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/company-profile.png",
      "alt": ""
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-white",
    attrs: {
      "id": "ecommerce"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/ecommerce.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tE-Commerce\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-grey2",
    attrs: {
      "id": "sisteminformasi"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tSistem Informasi\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet lorem")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/sisteminformasi.png",
      "alt": ""
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-white",
    attrs: {
      "id": "buildstartup"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/startup.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tBuild Start Up\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-page-wrapper bg-grey2",
    attrs: {
      "id": "webapplication"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "service-wrapper__info-service"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "service-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tWeb App\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Ab ipsum aspernatur repellat repudiandae maiores quam quaerat minima soluta itaque dolorum ad sequi hic, quod eligendi, cum numquam consequuntur veritatis totam.\n\t\t\t\t\t\t\t\t\t"), _c('ul', {
    staticClass: "no_bullet"
  }, [_c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', {
    staticClass: "check"
  }, [_vm._v("Lorem ipsum dolor sit amet")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "image-info"
  }, [_c('img', {
    attrs: {
      "src": "static/images/service/webapp.png",
      "alt": ""
    }
  })])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper",
    attrs: {
      "id": "technologies"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tTechnologies Use\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet totam officia facilis inventore asperiores illo animi nisi iusto maiores similique, explicabo sint a. Minus, labore, hic exercitationem at ab ea!\n\t\t\t\t\t\t\t")])])])])])])
}]}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "ShowPortofolio"
    }
  }, [_c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.msg) + " - " + _vm._s(this.$route.params.id))])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexHome"
    }
  }, [_c('section', {
    staticClass: "banner-top"
  }, [_c('div', {
    staticClass: "banner-top__image-background"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(59),
      "alt": "Corporate IT Profesional"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-description"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-default",
    attrs: {
      "to": 'about-us'
    }
  }, [_vm._v("\n              About Us\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "to": 'portofolios'
    }
  }, [_vm._v("\n              Portofolio\n            ")])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "intermezo-banner-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n              LIHAT SEMUA PORTOFOLIO\n            ")])], 1)])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('section', {
    staticClass: "point-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-block btn-lg btn-warning",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n                LIHAT SEMUA PORTOFOLIO\n              ")])], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.lates_project), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "list-portofolio"
    }, [_c('div', {
      staticClass: "list-portofolio__image"
    }, [_c('img', {
      attrs: {
        "src": project.client_logo_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-description"
    }, [_c('router-link', {
      staticClass: "title",
      attrs: {
        "to": 'portofolios/detail/3'
      }
    }, [_vm._v("\n                  " + _vm._s(project.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_vm._v("\n                  " + _vm._s(project.client_name) + "\n                ")])], 1)])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n              LIHAT SEMUA PORTOFOLIO\n            ")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_vm._v("\n              XPIT PILAR "), _c('br'), _vm._v("\n              IT Consultant\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v("Di era digital ini, teknologi informasi menjadi tulang punggung suksesnya bisnis dalam berbagai sektor.\n                Namun, dengan begitu banyaknya pilihan dan kompleksitas teknologi yang terus berkembang, tidaklah mudah\n                untuk menavigasi jalan Anda menuju kesuksesan di dunia digital.")]), _vm._v(" "), _c('p', [_vm._v("Itulah mengapa kami hadir di sini sebagai mitra yang dapat diandalkan untuk membantu Anda memahami,\n                mengimplementasikan, dan memanfaatkan teknologi informasi dengan optimal. Sebagai konsultan IT\n                berpengalaman, kami berkomitmen untuk memberikan solusi terbaik bagi bisnis Anda, membantu Anda\n                mengatasi\n                tantangan teknologi, dan mencapai tujuan bisnis yang lebih tinggi.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Ayo Buat aplikasimu sekarang juga!\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--wrapper service-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Our Services\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "service-wrapper__list-service"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/company-profile.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Company Profile\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/online-shop.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  E-Commerce\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/sistem-informasi.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Sistem Informasi\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/world-map.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Web App\n                ")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "list-service__box-icon"
  }, [_c('img', {
    attrs: {
      "src": "static/images/gallery/service/startup.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "list-service__title"
  }, [_vm._v("\n                  Build Start Up\n                ")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "point-wrapper__box-title-top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                  Kebutuhan Teknologi\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat numquam eum incidunt, eos a, magnam\n                  maxime aliquam. A nobis sunt vitae.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "point-wrapper__box-point"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "point-wrapper__box-counting"
  }, [_c('div', {
    staticClass: "box-head"
  }, [_c('div', {
    staticClass: "count-big"
  }, [_vm._v("\n                    50\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "count-desc"
  }, [_vm._v("\n                    total client\n                  ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('p', [_c('span', [_vm._v("30")]), _vm._v(" company\n                  ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("10")]), _vm._v(" online store\n                  ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("05")]), _vm._v(" goverment\n                  ")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("05")]), _vm._v(" personal\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              latest project\n            ")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Pagenotfound"
    }
  }, [_c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.msg))])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexRegistration"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "cname"
    }
  }, [_vm._v("Company Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cname),
      expression: "cname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nama Instansi"
    },
    domProps: {
      "value": (_vm.cname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Alamat Instansi"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "telpnum"
    }
  }, [_vm._v("Telp. Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telpnum),
      expression: "telpnum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nomor Telepon"
    },
    domProps: {
      "value": (_vm.telpnum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telpnum = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "cperson"
    }
  }, [_vm._v("Contact Person")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cperson),
      expression: "cperson"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Contact Person"
    },
    domProps: {
      "value": (_vm.cperson)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cperson = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "region"
    }
  }, [_vm._v("Region")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.region),
      expression: "region"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Region e.g Jawa Tengah"
    },
    domProps: {
      "value": (_vm.region)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.region = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sub--header diagonal-shadow mg-bottom-diagonal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Registration\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos\n              nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime\n              voluptatem, fugit laboriosam assumenda?\n            ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              FORM REGISTRATION\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("\n                  Kirim\n                ")])])
}]}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "header-corporate"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": '/'
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": __webpack_require__(58),
      "alt": "logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-menu-top"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      },
      "exact": ""
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/about-us'
      },
      "exact": ""
    }
  }, [_vm._v("About Us")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/services'
      },
      "exact": ""
    }
  }, [_vm._v("Services")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/portofolios'
      },
      "exact": ""
    }
  }, [_vm._v("Portofolio")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact-us'
      },
      "exact": ""
    }
  }, [_vm._v("Contact Us")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/registration'
      },
      "exact": ""
    }
  }, [_vm._v("Registration")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar-menu-top",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexContactus"
    }
  }, [_c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.msg))])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexAbouts"
    }
  }, [_c('section', {
    staticClass: "sub--header diagonal-shadow mg-bottom-diagonal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAbout us\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'apply-project'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t  Konsultasikan pada kami\n\t\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper bg-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.about_us) ? _c('div', {
    staticClass: "box-information"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.about_us.title) + "\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.about_us.short_desc) + "\n\t\t\t\t\t\t\t\t")])])]) : _vm._e()])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper about-us"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.team), function(t) {
    return _c('div', {
      key: t.name,
      staticClass: "box-list-team"
    }, [_c('div', {
      staticClass: "box-list-team__image"
    }, [_c('img', {
      attrs: {
        "src": t.foto_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "box-list-team__name"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(t.name) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box-list-team__position"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(t.position) + "\n\t\t\t\t\t\t\t")])])
  }), 0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tCOMPANY PROFILE DOWNLOAD\n\t\t\t\t\t\t\t")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title txt-white"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPerkenalkan Team Kami\n\t\t\t\t\t\t\t")])])])])
}]}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexPortofolios"
    }
  }, [_c('section', {
    staticClass: "sub--header diagonal-shadow mg-bottom-diagonal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPortofolio\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'apply-project'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t  Konsultasikan pada kami\n\t\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.portofolio), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "list-portofolio"
    }, [_c('div', {
      staticClass: "list-portofolio__image"
    }, [_c('img', {
      attrs: {
        "src": project.client_logo_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-description"
    }, [_c('router-link', {
      staticClass: "title",
      attrs: {
        "to": 'portofolios/detail/3'
      }
    }, [_vm._v("\n                    " + _vm._s(project.title) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_vm._v("\n                    " + _vm._s(project.client_name) + "\n                  ")])], 1)])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tlatest project\n\t\t\t\t\t\t\t")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexApplyproject"
    }
  }, [_c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    class: {
      'control': true
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true,
      'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n                      " + _vm._s(_vm.errors.first('email')) + "\n                    ")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              formulir apply project\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Nama Lengkap")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Website URL")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Dapat dari mana info kami")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Pilih salah satu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Internet")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Teman")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Telepon")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Plan to Start")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Pesan anda")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Masukan Dokumen anda")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("\n                    Kirim\n                  ")])])
}]}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "footer-wrapper box-desc-social"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "list-info"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                About Company\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                  Lorem ipsum dolor sit amet, consectetur adipisicing elit. Optio minus incidunt, quos libero a illo\n                  amet deleniti tempore, modi obcaecati autem vitae, labore doloribus reiciendis veniam quod minima\n                  quibusdam reprehenderit!\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "list-info"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                Contact Us\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("\n                  Address: Jl TB Simatupang No.30 Gd Talavera Suite 6 BGH\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  Phone: 085692268882\n                ")]), _vm._v(" "), _c('p', [_vm._v("\n                  Email: sales@xpitpilar.com\n                ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "box-desc-social"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Follow Us\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "social-media"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "http://facebook.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "href": "http://twitter.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    attrs: {
      "href": "http://google.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "http://linkedin.com"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-corpyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("2023 © Corpyright - XPIT PILAR")])])])])])])
}]}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('appHeader'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('appFooterintermezo'), _vm._v(" "), _c('appFooter')], 1)
},staticRenderFns: []}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Footerintermezo"
    }
  }, [_c('section', {
    staticClass: "intermezo-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "to": 'portofolios'
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v("\n                LIHAT SEMUA PORTOFOLIO\n              ")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('div', {
    staticClass: "box-info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                  Ayo buat aplikasimu sekarang juga\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n                  Dengan kami Brand anda semuanya menjadi lebih profesional\n                ")])])])
}]}

/***/ })
],[32]);


// WEBPACK FOOTER //
// static/js/app.922d305f9e52a39f66cd.js